var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 32,
    viewBox: "0 0 141 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.067%",
    y1: "4.947%",
    x2: "26.378%",
    y2: "71.933%",
    id: "jhktjkoifa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: ".7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.595%",
    y1: "50.007%",
    x2: "-130.516%",
    y2: "50.007%",
    id: "gz0bugu2lb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "orange",
    offset: "77.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.245%",
    y1: "30.96%",
    x2: "-50.123%",
    y2: "135.748%",
    id: "rpxm5g18ac"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.805%",
    y1: "-11.628%",
    x2: "42.087%",
    y2: "35.137%",
    id: "3gzyudhs0d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.567.49C.207.878 0 1.473 0 2.247v27.503c0 .773.207 1.368.58 1.742l.098.082 15.436-15.41v-.347L.665.408.567.491z",
    fill: "url(#jhktjkoifa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.249 21.32 16.1 16.176v-.36l5.15-5.141.111.068 6.092 3.456c1.744.982 1.744 2.6 0 3.594L21.36 21.25l-.112.07z",
    fill: "url(#gz0bugu2lb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 21.25-5.26-5.253L.567 31.506c.568.608 1.522.677 2.59.082L21.36 21.25",
    fill: "url(#rpxm5g18ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.36 10.746 3.157.422C2.09-.187 1.135-.104.567.504l15.531 15.493 5.262-5.25z",
    fill: "url(#3gzyudhs0d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.249 21.14 3.17 31.394c-1.01.58-1.91.54-2.492.013l-.097.098.097.082c.581.525 1.482.567 2.492-.013L21.373 21.25l-.124-.11z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.45 17.614-6.215 3.525.111.111 6.091-3.456c.872-.497 1.302-1.146 1.302-1.797-.056.595-.499 1.162-1.288 1.617z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.157.602 24.294 13.78c.79.442 1.232 1.022 1.301 1.617 0-.649-.43-1.3-1.301-1.797L3.157.422C1.413-.573 0 .255 0 2.246v.18C0 .435 1.413-.38 3.157.601z",
    fill: "#FFF",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#808285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.682 15.125c0-4.406 3.709-7.993 8.121-7.993 2.44 0 4.176.957 5.486 2.202l-1.543 1.54c-.936-.878-2.205-1.558-3.944-1.558-3.223 0-5.741 2.59-5.741 5.807 0 3.218 2.518 5.811 5.74 5.811 2.088 0 3.277-.837 4.04-1.6.624-.624 1.033-1.52 1.192-2.748h-5.23v-2.179h7.361c.078.39.118.857.118 1.363 0 1.636-.45 3.665-1.896 5.109-1.407 1.462-3.202 2.242-5.584 2.242-4.415 0-8.124-3.584-8.124-7.993l.004-.003zm21.55-2.3c-2.85 0-5.177 2.165-5.177 5.146 0 2.965 2.325 5.145 5.177 5.145 2.852 0 5.173-2.183 5.173-5.147 0-2.98-2.323-5.145-5.173-5.144zm0 8.267c-1.561 0-2.91-1.286-2.91-3.12 0-1.852 1.347-3.12 2.91-3.12 1.56 0 2.907 1.266 2.907 3.12 0 1.833-1.345 3.12-2.907 3.12zm11.288-8.267c-2.85 0-5.174 2.165-5.174 5.146 0 2.965 2.324 5.145 5.174 5.145 2.85 0 5.174-2.183 5.174-5.147 0-2.98-2.322-5.145-5.174-5.144zm0 8.267c-1.56 0-2.91-1.286-2.91-3.12 0-1.852 1.348-3.12 2.91-3.12 1.56 0 2.91 1.266 2.91 3.12 0 1.833-1.35 3.12-2.91 3.12zm13.854-7.954v.837h-.077c-.507-.607-1.483-1.151-2.712-1.151-2.578 0-4.943 2.262-4.943 5.169 0 2.882 2.363 5.126 4.943 5.126 1.229 0 2.205-.544 2.712-1.168h.077v.74c0 1.968-1.054 3.022-2.752 3.022-1.388 0-2.246-.995-2.598-1.83l-1.973.818c.565 1.364 2.07 3.041 4.569 3.041 2.653 0 4.9-1.562 4.9-5.362v-9.244l-2.146.002zm-2.596 7.954c-1.56 0-2.872-1.307-2.872-3.1 0-1.811 1.31-3.138 2.872-3.138 1.542 0 2.753 1.325 2.753 3.139.002 1.792-1.209 3.1-2.753 3.1zm6.305-13.414h2.266v15.129h-2.266V7.678zm8.477 13.414c-1.151 0-1.973-.528-2.497-1.558l6.893-2.85-.237-.584c-.428-1.148-1.738-3.275-4.413-3.275-2.655 0-4.862 2.086-4.862 5.147 0 2.883 2.187 5.146 5.116 5.146 2.364 0 3.731-1.44 4.297-2.281l-1.758-1.168c-.588.858-1.389 1.425-2.539 1.423zm-.177-6.278c.898 0 1.659.449 1.913 1.09l-4.61 1.912c-.057-1.988 1.544-3.002 2.697-3.002zM111.9 7.678h-5.419v15.129h2.262v-5.73h3.158c2.507 0 4.972-1.813 4.972-4.7 0-2.883-2.464-4.697-4.969-4.697l-.005-.002zm.058 7.292h-3.215V9.783h3.215c1.69 0 2.653 1.4 2.653 2.594 0 1.173-.963 2.593-2.653 2.593zm8.421 7.837V7.678h-2.26v15.129h2.26zm10.158-.027v-5.8c0-2.685-2.01-4.183-4.605-4.183-1.635 0-3.33.721-4.032 2.316l2.007.836c.429-.836 1.227-1.11 2.067-1.11 1.168 0 2.357.701 2.376 1.948v.157c-.41-.234-1.285-.585-2.36-.585-2.163 0-4.365 1.187-4.365 3.405 0 2.026 1.775 3.329 3.763 3.329 1.522 0 2.359-.681 2.884-1.478h.078v1.168h2.185l.002-.003zm-4.874-1.691c-.741 0-1.775-.37-1.775-1.283 0-1.168 1.288-1.618 2.4-1.618.994 0 1.46.213 2.067.506a2.746 2.746 0 0 1-2.692 2.395zm12.825-7.961-2.593 6.557h-.077l-2.69-6.557h-2.437l4.034 9.168-2.301 5.098h2.359L141 13.128h-2.512z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.2d1f88f53da1e1497fd9cf956d1755df.svg";
export { ForwardRef as ReactComponent };